import clsx from 'clsx';
import SourceFileTag from '../../../../../../../../common/SourceFileTag/SourceFileTag';
import { getReferenceDocumentsRow } from '../../../../../../../../common/SourceFileTag/referenceDocumentsRow';
import { HEADER_TYPE } from '../../../../../../../../store/dashboard/auditedFinancials/constants';
import { isAnnualisedPartialHeader, getAnnualisedFyLabel } from '../../annualisedHeader';
import type { ReferenceDocumentsRowHeader, ReferenceDocumentsRowProps } from '../../types';
import styles from '../../FinancialMetrics.module.scss';

// The head cell relabels an annualised column "FY'27 (Annu.)*", not its raw `name` ("FY'27 (Aug'26)") —
// title the popover the same way, or it names a different column than the one it sits under.
const getColumnLabel = (header: ReferenceDocumentsRowHeader) =>
    isAnnualisedPartialHeader(header) ? getAnnualisedFyLabel(header) : header.name;

function ReferenceDocumentsRow({ headers, sourceFilesStatus, gridTemplateColumns, onOpen }: ReferenceDocumentsRowProps) {
    const row = getReferenceDocumentsRow({ sourceFilesStatus, onOpen, getColumnLabel });
    if (!row) return null;

    return (
        <div className={styles.TableBodyRow} style={{ gridTemplateColumns }}>
            {headers.map((header, i) => (
                <div
                    key={header.key}
                    className={clsx(styles.TableBodyRowItem, {
                        [styles.audited]: i !== 0 && header.type === HEADER_TYPE.AUDITED_FINANCIALS,
                        [styles.provisional]: i !== 0 && header.type === HEADER_TYPE.PROVISIONAL_FINANCIALS,
                    })}
                >
                    {i === 0 ? (
                        row.label
                    ) : (
                        <div className={styles.ReferenceDocumentsTag}>
                            <SourceFileTag {...row.getTagProps(header)} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}

export default ReferenceDocumentsRow;
